<template>
  <TransitionRoot
    :show="isOpen"
    as="template"
  >
    <Dialog
      as="div"
      class="relative z-50"
      @close="closeModal"
    >
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 transition-opacity bg-gray-blue-100/90" />
      </TransitionChild>
      
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex justify-center min-h-full p-4 items-center sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel class="relative max-w-2xl overflow-hidden transition-all transform bg-white border shadow-xl lg:w-full lg:max-w-4xl border-gray-blue-200">
              <div class="absolute top-0 right-0 md:pr-4 md:pt-4 sm:block">
                <button
                  type="button"
                  class="btn p-2.5 btn--gray border-none shadow-none"
                  @click="closeModal"
                >
                  <span class="sr-only">Close Quick View Modal</span>
                  <SvgIcon
                    aria-hidden="true"
                    icon-name="close"
                    class="w-5 h-5"
                  />
                </button>
              </div>
              <Suspense>
                <!-- component with nested async dependencies -->
                <QuickViewContent />

                <!-- loading state via #fallback slot -->
                <template #fallback>
                  <QuickViewLoader />
                </template>
              </Suspense>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script lang="ts">
export default { name: 'QuickViewModal', components: { QuickViewLoader } }
</script>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { Dialog, DialogPanel, TransitionRoot, TransitionChild } from '@headlessui/vue'
import { computed, defineAsyncComponent } from 'vue'
import axios from 'axios'

import SvgIcon from '../../global/SvgIcon.vue'
import { useUiStore } from '~/store/modules/ui'

import QuickViewLoader from './QuickViewLoader.vue'

const uiStore = useUiStore()
const { quickViewModal } = storeToRefs(uiStore)
const isOpen = computed(() => quickViewModal.value !== '')

const QuickViewContent = defineAsyncComponent(() => new Promise(async (resolve) => {
  const { data } = await axios.get(`${quickViewModal.value}?quickView=1`)
  resolve({
    template: data,
  })
}),
)

const closeModal = ():void => {
  uiStore.toggleQuickViewModal('')
}
</script>
